// @flow
import * as React from 'react';

import useEffectOnce from 'common/hooks/useEffectOnce';
import useLatest from 'common/hooks/useLatest';

const EVENTS_TO_TRACK = [
    // clicking
    'mousedown',
    // scrolling page
    'mousewheel',
    // typing something
    'keydown'
];

const useOnActivity = (onActivity: () => void) => {
    const onActivityRef = useLatest(onActivity);

    useEffectOnce(() => {
        //Page Load Event
        onActivityRef.current();
    });

    React.useEffect(() => {
        const handleEvent = () => {
            onActivityRef.current();
        };

        EVENTS_TO_TRACK.forEach(event => {
            document.addEventListener(event, handleEvent);
        });

        return () => {
            EVENTS_TO_TRACK.forEach(event => {
                document.removeEventListener(event, handleEvent);
            });
        };
    }, [onActivityRef]);
};

export default useOnActivity;
